"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Styled = require("styled-components");
exports.Global = Styled.createGlobalStyle `
  html,
  body {
    margin: 0;
  }
`;
//# sourceMappingURL=global.js.map